import { LoadingButton } from "@mui/lab";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { deletingShift } from "utils/Schedule";

const DeleteShift = ({ open, setOpen, shiftId, setShiftId, reloading }) => {
	const { t } = useTranslation();

	const [loadingDeletingShift, setLoadingDeletingShift] = useState(false);

	const closing = () => {
		setOpen(false);
		setShiftId(null);
	};

	return (
		<>
			<Dialog
				fullWidth
				open={open}
				onClose={() => {
					closing();
				}}
			>
				<DialogTitle
					sx={{
						background: (theme) => theme.palette.background.default,
					}}
				>
					<Typography variant="body3">{"Eliminar turno"}</Typography>
				</DialogTitle>

				<DialogContent
					dividers
					sx={{
						background: (theme) => theme.palette.background.default,
					}}
				>
					<Typography variant="body3">
						{"¿Estás seguro de que deseas eliminar este turno?"}
					</Typography>
				</DialogContent>

				<DialogActions
					sx={{
						background: (theme) => theme.palette.background.default,
					}}
				>
					<Button
						variant="contained"
						disableElevation
						color="error"
						onClick={() => {
							closing();
						}}
					>
						{t(
							"settings.paycodes.table.modals.edit.buttons.cancel"
						)}
					</Button>

					<LoadingButton
						sx={{ mr: 2.25 }}
						variant="contained"
						disableElevation
						onClick={() => {
							deletingShift(
								setLoadingDeletingShift,
								shiftId,
								closing,
								reloading
							);
						}}
						loading={loadingDeletingShift}
						disabled={loadingDeletingShift}
					>
						{t(
							"timekeeper.schedule.table.modals.edit.segments.buttons.delete"
						)}
					</LoadingButton>
				</DialogActions>
			</Dialog>
		</>
	);
};

export { DeleteShift };
